import { Component } from '@angular/core';

@Component({
  selector: 'app-header-toast-message',
  templateUrl: './header-toast-message.component.html',
  styleUrls: ['./header-toast-message.component.scss'],
  standalone: false,
})
export class HeaderToastMessageComponent {
  private _toastBanners: ToastBanner[] = [];
  public get toastBanners(): ToastBanner[] {
    return this._toastBanners;
  }

  public onActionClick(banner: ToastBanner): void {
    banner.action?.(banner.id ?? 0);
  }

  public addBanner(_banner: Partial<ToastBanner>): number {
    const index = this._toastBanners.length;
    const banner: ToastBanner = { ..._banner, id: index };
    this._toastBanners.push(banner);
    return index;
  }

  public replace(_banner: Partial<ToastBanner>, id: number): number {
    const banner = this._toastBanners.find((b) => b.id === id);
    if (!banner) {
      return this.addBanner(_banner);
    }
    banner.message = _banner.message;
    banner.buttonText = _banner.buttonText;
    banner.action = _banner.action;
    return banner.id;
  }

  public removeBanner(id: number): void {
    this._toastBanners = this.toastBanners.filter((banner) => banner.id !== id);
  }

  public removeAll(): void {
    this._toastBanners = [];
  }
}

export interface ToastBanner {
  message?: string;
  buttonText?: string;
  action?: (id: number) => void;
  id: number;
}
